export default __webpack_public_path__ + "static/media/ketochickennuggets-wide@2x.41afa4f8.jpg";